import { render, staticRenderFns } from "./AddBusinessPrivacyPolicy.vue?vue&type=template&id=0b741e34&"
import script from "./AddBusinessPrivacyPolicy.vue?vue&type=script&lang=js&"
export * from "./AddBusinessPrivacyPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports